'use strict';

angular.module('mediacloudApp')
    .factory('Activate', function ($resource) {
        return $resource('api/activate', {}, {
            'post': { method: 'POST' }
        });
    });


